export default __webpack_public_path__ + "static/media/tittle.17a79972.png";